module.exports = __webpack_public_path__ + "img/step4-10.5ef4805e.jpg";